<template>
  <div
    class="table-grid-td"
    :class="{ 'table-grid-td--left-border': props.isLeftBorder }"
    ref="$el"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { PropType, ref } from "vue";
const $el = ref<HTMLElement>();

const props = defineProps({
  /**
   * Отключить или включить бордер слева ячейки
   */
  isLeftBorder: { type: Boolean as PropType<Boolean>, default: true },
});
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
